import { Helmet } from "react-helmet-async";

const SITE_NAME = "MicroDegree";
const DEFAULT_IMAGE = "https://www.microdegree.work/logo512.png";

const SEO = ({ title, description, canonical, schema, robots, image = DEFAULT_IMAGE }) => {
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>

      {description && (
        <meta name="description" content={description} />
      )}

      {robots && (
        <meta name="robots" content={robots} />
      )}

      {canonical && (
        <link rel="canonical" href={canonical} />
      )}

      {/* Open Graph / Twitter — derived from the same title/description/canonical */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      {canonical && (
        <meta property="og:url" content={canonical} />
      )}
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
